// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Open_Sans_f58ecf', '__Open_Sans_Fallback_f58ecf'","fontStyle":"normal"},"className":"__className_f58ecf","variable":"__variable_f58ecf"};